// https://github.com/helpers/handlebars-helpers/blob/master/lib/string.js#L596
// the titilize function provided by hbs does not remove the - in the string
export default function titleizeString(value) {
  const title = value.replace(/[- _]+/g, ' ');
  const words = title.split(' ');
  let len = words.length;
  const res = [];
  let i = 0;
  while (len--) {
    var word = words[i++];
    res.push(word.charAt(0).toUpperCase() + word.slice(1));
  }
  return res.join(' ');
}
